import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';

function PurchaseCanceled({match, history}) {
    const {t} = useTranslation();  
    const [status, setStatus] = useState(t('PURCHASE_CANCELED'))

    return (
        <div className="col" style={{textAlign:'center', maxWidth:"400px", margin:'auto', marginTop:'50px'}}>
            {status}
        </div>
    )
}

export default PurchaseCanceled;